import ProfileSection from '../components/settings/ProfileSection';
import DocumentTemplateSection from '../components/settings/DocumentTemplateSection';
import RolesSection from '../components/settings/RolesSection';

export default function Settings() {
  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-2xl font-bold text-navy-900 dark:text-navy-50">Configurações</h1>
        <p className="text-navy-500 dark:text-navy-400 text-sm mt-1">
          Gerencie suas preferências e personalizações
        </p>
      </div>

      <ProfileSection />
      <DocumentTemplateSection />
      <RolesSection />
    </div>
  );
}
